(() => {
  if (window.moonroadFacetA11yInitialized) return;
  window.moonroadFacetA11yInitialized = true;
  document.documentElement.setAttribute('data-moonroad-retail-js', 'ready');

  let activeTrigger = null;

  const isVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const getDrawer = (trigger) => {
    const drawerId = trigger && trigger.getAttribute('aria-controls');
    return drawerId ? document.getElementById(drawerId) : null;
  };

  const getFocusable = (drawer) => Array.from(drawer.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
  )).filter(isVisible);

  const finishClose = () => {
    if (!activeTrigger) return;
    const trigger = activeTrigger;
    const drawer = getDrawer(trigger);
    trigger.setAttribute('aria-expanded', 'false');
    if (drawer) {
      drawer.removeAttribute('role');
      drawer.removeAttribute('aria-modal');
      drawer.removeAttribute('aria-label');
    }
    activeTrigger = null;
    window.setTimeout(() => trigger.focus(), 0);
  };

  const startOpen = (trigger) => {
    activeTrigger = trigger;
    window.setTimeout(() => {
      const drawer = getDrawer(trigger);
      if (!drawer) return;
      trigger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-label', trigger.textContent.trim());
      const closeButton = Array.from(drawer.querySelectorAll('.js-close-filters')).find(isVisible);
      if (closeButton) closeButton.focus();
    }, 0);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.js-show-filters, .js-show-sort');
    if (trigger) {
      startOpen(trigger);
      return;
    }

    if (event.target.closest('.js-close-filters') && activeTrigger) {
      finishClose();
    }
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('.js-show-filters, .js-show-sort');
    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      startOpen(trigger);
      return;
    }

    if (!activeTrigger) return;
    const drawer = getDrawer(activeTrigger);
    if (!drawer) return;

    if (event.key === 'Escape') {
      const closeButton = Array.from(drawer.querySelectorAll('.js-close-filters')).find(isVisible);
      if (closeButton) {
        event.preventDefault();
        closeButton.click();
      }
      return;
    }

    if (event.key !== 'Tab' || !drawer.contains(document.activeElement)) return;
    const focusable = getFocusable(drawer);
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
